/**
 * @param {string} text
 * */
 function copy(text) {
  if (!text) return new Error('복사할 텍스트를 넣어주세요.');

  const input = document.createElement('input');
  input.style.opacity = '0';
  input.style.position = 'absolute';
  input.id = 'copyElem';
  input.value = text;
  
  document.body.appendChild(input);

  input.select();
  document.execCommand('copy');

  input.remove();
}

export default copy;
